module.exports = __webpack_public_path__ + "static/assets/b21ffefbff9cadc064cb07aa4034832c.svg";